/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppBlockquote.vue?vue&type=template&id=52726dde&scoped=true"
import script from "./AppBlockquote.ts?vue&type=script&lang=ts&external"
export * from "./AppBlockquote.ts?vue&type=script&lang=ts&external"
import style0 from "./AppBlockquote.vue?vue&type=style&index=0&id=52726dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52726dde",
  null
  
)

export default component.exports